export default __webpack_public_path__ + "static/media/lab-activity-04.bbee4efc.jpg";